export default {"src":"/_next/static/media/avatar-black.ebf951ec.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};